import { render, staticRenderFns } from "./GradeMapping.vue?vue&type=template&id=0aecda4e&"
import script from "./GradeMapping.vue?vue&type=script&lang=js&"
export * from "./GradeMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports